export default {
      id: "i-noun-education-usage",
      viewBox: "0 0 44 25",
      url: __webpack_public_path__ + "img/sprite.svg#i-noun-education",
      toString: function () {
        return this.url;
      }
    }